module.exports = __webpack_public_path__ + "static/media/edu-boom.69e382d1.svg";